<template>
  <div id="searchContractorResult">
    <v-list three-line>
      <template v-for="contractorCompany in filteredContractorCompanies">
        <v-list-item
          :key="`search-result-${contractorCompany._id}`"
          exact
          :to="`/contractors/${contractorCompany._id}/profile`"
          ripple
        >
          <v-list-item-avatar color="primary">
            <v-icon dark>perm_contact_calendar</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <text-highlight :queries="filter">{{
                contractorCompany.contractor.name
              }}</text-highlight>
            </v-list-item-title>
            <v-list-item-subtitle
              >{{
                contractorCompany.contractor.identifier.type.toUpperCase()
              }}&nbsp;<text-highlight :queries="filter">{{
                contractorCompany.contractor.identifier.number
              }}</text-highlight></v-list-item-subtitle
            >
            <v-list-item-subtitle
              ><text-highlight :queries="filter">{{
                contractorCompany.type.name
              }}</text-highlight></v-list-item-subtitle
            >
            <v-list-item-subtitle
              v-if="$store.state.auth.user.company.isBuiltIn"
              >{{
                contractorCompany.company && contractorCompany.company.name
              }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action v-if="contractorCompany.contractor.avgRate">
            <v-list-item-action-text>
              <v-icon
                color="success"
                :size="20"
                class="d-inline-block star-rating"
                >star_rate</v-icon
              >
              <span class="subheading ml-1"
                >({{ contractorCompany.contractor.avgRate }})</span
              >
            </v-list-item-action-text>
          </v-list-item-action>
          <v-list-item-action>
            <v-icon color="primary">chevron_right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="contractorCompany._id"></v-divider>
      </template>
    </v-list>
    <v-alert
      :value="
        filteredContractorCompanies &&
          filteredContractorCompanies.length == 0 &&
          !filter  
      "
      type="info"
      transition="scale-transition"
    >
      {{ resx.messages.searchContractorHelpMessage }}
    </v-alert>
    <v-alert
      :value="showNoMatchingRecordsFound"
      type="warning"
      transition="scale-transition"
    >
      {{ resx.messages.noMatchingRecordsFound }}
    </v-alert>
  </div>
</template>

<script>
"use strict";

import _ from "lodash";
import TextHighlight from "vue-text-highlight";

import contractorCompanyService from "@/services/ContractorCompanyService";

export default {
  name: "searchContractorResults",
  components: {
    TextHighlight
  },
  data() {
    return {
      contractorCompanies: [],
      filteredContractorCompanies: [],
      showNoMatchingRecordsFound: false
    };
  },
  methods: {
    async filterContractorCompanies(filterText) {
      filterText = filterText.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "");
      const re = new RegExp(filterText, "i");
      this.filteredContractorCompanies = await this.contractorCompanies.filter(c => {
        return re.test(c.contractor.name.toString().normalize('NFD').replaceAll(/[\u0300-\u036f]/g, ""))
        || re.test( filterText.indexOf("-") == -1 ? c.contractor.identifier.number.replaceAll("-", "")
        : c.contractor.identifier.number);
      });
      this.showNoMatchingRecordsFound = this.filteredContractorCompanies.length == 0 && filterText;
    }
  },
  props: ['filter'],
  async mounted() {
    this.contractorCompanies = await contractorCompanyService.list();
  },
  watch: {
    filter: {
        handler() {
            this.debouncedSearch();
        },
        deep: true
    }
  },
  created() {
    this.debouncedSearch = _.debounce(
        async () => {
            if (this.filter && this.filter.trim() != null) {
                await this.filterContractorCompanies(this.filter);
            } else {
                this.filteredContractorCompanies = [];
                this.showNoMatchingRecordsFound = false;
            }
        },
    process.env.NODE_ENV == "development" ? 300 : 2000)
  }
};
</script>

<style lang="scss">
#searchContractorResult {
  .star-rating {
    max-width: 16px;
  }
}
</style>
